import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { CustomerStatusForm } from 'page-components/customer-statuses/CustomerStatusForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const CustomerStatus = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.customerStatusCreate ? 'create_customer_status' : 'edit_customer_status';
  const titleText = pathname.includes('view') ? 'view_customer_status' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <CustomerStatusForm />
    </PageLayout>
  );
};
